module.exports = "https://www.gc-qa.gnp.com.mx/21d9ebc4d22a0ac7ed23489d411efcc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/vida/6.png
// module id = 1065
// module chunks = 0 1